import React, { createContext, useState, useContext, useEffect } from "react";

const AuthContext = createContext();

const getStoredAuth = () => ({
  token: localStorage.getItem("token"),
  role: localStorage.getItem("role"),
  user: localStorage.getItem("name"),
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getStoredAuth().user);
  const [token, setToken] = useState(getStoredAuth().token);
  const [role, setRole] = useState(getStoredAuth().role);

  useEffect(() => {
    const handleLogout = () => {
      setUser(null);
      setToken(null);
      setRole(null);
    };
    window.addEventListener("auth:logout", handleLogout);
    return () => window.removeEventListener("auth:logout", handleLogout);
  }, []);

  const login = (role, token, name) => {
    // Implement login logic here (e.g., API request)
    setToken(token);
    setUser(name);
    setRole(role);
    localStorage.setItem("token", token);
    localStorage.setItem("name", name);
    localStorage.setItem("role", role);
  };

  const signup = (userData) => {
    // Implement signup logic here (e.g., API request)
    setUser(userData);
  };

  const logout = () => {
    // Implement logout logic here (e.g., clear user data)
    setUser(null);
    setToken(null);
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("role");

    localStorage.clear();
  };

  return (
    <AuthContext.Provider value={{ token, user, role, login, signup, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
